import { useEffect } from 'react';
import { useParams } from 'react-router-dom';

const ScrollToTop = () => {
    const params = useParams();
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [params]);
    return (null);
};

export default ScrollToTop;
